import { createAppSystem } from '@/lib/platform/system';
import { features } from './features';

export const app = createAppSystem(features);
export const { appActor, feature, useFeature, useOverlayOpen, ui } = app;
